// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"tab_navWrapper__1AVIG","navigator":"tab_navigator__aQ43Z","rightOption":"tab_rightOption__3VTwc","verticalLine":"tab_verticalLine__2OTyQ"};